import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../context/UserContext'
import { Form, Col,  } from 'react-bootstrap'
import { Dropdown } from 'primereact/dropdown'
import css from '../AnuncioForm.module.css'
import { linkApi } from '../../config'

export default function Fuels({ values, setFieldValue }) {
    const [fuels, setFuels] = useState([])
    const { user } = useContext(UserContext)

    const handleDropdownChange = (e) => {
        setFieldValue('fuel.id', e.target.value)
        setFieldValue('segment.id', '')
        setFieldValue('engine.power_cv', '')
        setFieldValue('version.id', '')
    }

    useEffect(() => {
        let model = values.model.id
        let years = values.registration.year

        const getData = async () => {
            const options = {
                method: 'GET',
                headers: {
                    authorization: 'Bearer ' + user.token,
                },
            }

            const res = await fetch(
                `${linkApi}/v1/cars/fuels/${model}/?ano=${years}`,
                options
            )
                .then((response) => response.json())
                .catch((err) => console.error(err))

            setFuels(res.data)
        }

        getData()
    }, [user.token, values.model.id, values.registration.year])

    return (
        <div>
            <Form.Group as={Col} controlId="validationFormik03">
                <Form.Label className={css.label}>Combustíveis</Form.Label>
                <Dropdown
                    value={values.fuel.id}
                    onChange={handleDropdownChange}
                    options={fuels}
                    placeholder="Escolher"
                    filter
                    // disabled
                    optionLabel="name"
                    optionValue="id"
                    className="w-full md:w-14rem"
                    style={{ width: '-webkit-fill-available' }}
                />
            </Form.Group>
        </div>
    )
}
